'use strict';

customerZone

/**
 * Adds a context-specific menu, showing 'sibling-pages' according to the routing config.
 * All pages sharing the 'context' field with the current route will be shown, and the current highlighted.
 */
.component('context', {
    bindings: {
        title: '@'
    },
    templateUrl: customerZone.fromBase('components/context/context.component.html'),
    controller: ['$location', '$route', 'Session',
        function($location, $route, session){
            var vm = this;
            var allRoutes = $route.routes;

            vm.isActive = function(item) {
                return $location.path() === item.link;
            };

            vm.$onInit = function(){
                vm.items =
                    Object.keys(allRoutes)
                        // get all values
                        .map(function(key){ return allRoutes[key]; })
                        // get all routes with the current context
                        .filter(function(route){ return route.context && route.context.id === vm.title; })
                        // filter the ones that are not accessible
                        .filter(function(route){ return !route.accessible || route.accessible(session); })
                        // sort them by position
                        .sort(function(r1, r2) { return r1.context.position - r2.context.position; })
                        // and turn them into context items
                        .map(function(route){ return {title: route.title, link: route.originalPath}; });
            };
        }
    ],
    controllerAs: 'vm'
});
